import UOE_MobileNav from './UOE.Mvc.Helpers.Presentation/UOE.MobileNav';
$(document).ready(function () {
    $("#ToggleSidebar").click(function () {
        var $cwp = $("#subnav").parent();
        if ($cwp.hasClass("collapseSidebar")) {
            $cwp.removeClass("collapseSidebar");
        }
        else {
            $cwp.addClass("collapseSidebar");
        }
    });
    var DocumentExclusionSelectors = ":has(img), .btn, .no-link-dec";
    //comma-separated list of conditions which mean that we won't decorate this link
    //with the extra class for its document type (eg PDF). We still apply
    //all other logic like the external link indicator.
    // Add 'upload' class to upload links, open them in new window
    $('#content').find("a:pathStartsWith(/upload/)")
        .not("a[href$='/']")
        .openNewWindow()
        .not(DocumentExclusionSelectors)
        .addClass("document")
        .addExtensionClass()
        .decorate(function (info) {
        if (info.formattedSize) {
            $(this).append("<span class='ol'>[" + info.EXT + ": " + info.formattedSize + "] - opens in new window</span>");
        }
        else {
            $(this).append("<span class='ol'>[" + info.EXT + "] - opens in new window</span>");
        }
    });
    // Static links that open new window
    $('#content').find("a[target='_blank']")
        .not("a:pathStartsWith(/upload/)")
        .append("<span class='ol'>[Opens new window]</span>");
    // Email links
    $('#content, footer').find("a:email")
        .openNewWindow()
        .addClass("email")
        .append("<span class='ol'>[E-mail]</span>");
    // Links off-site 
    $('#content, footer').find("a:external")
        .openNewWindow()
        .addClass("external")
        .append("<span class='ol'>[External Link]</span>");
    var UMN = new UOE_MobileNav();
    UMN.Initialize();
    // Enable tooltips everywhere.
    $('[data-toggle="tooltip"]').tooltip();
});
var AddAntiForgeryToken = function (data) {
    data.__RequestVerificationToken = $('#__AjaxAntiForgeryForm input[name=__RequestVerificationToken]').val();
    return data;
};
